import React from 'react'
import { colorRes, getDateOrTimeToReport, getHourAndMinutesFromSeconds, getIconByResoruce, getTimeDiference, getTranlationByKey } from '../entryAndDepartureHelper';

export const EntryAndDepartureList = ({ data, setShowDetailModal, setResourceInfo }) => {

    const fontStyleOne = { color: 'var(--gray-950)', fontSize: '14px', fontWeight: '700' }
    const fontStyleTwo = { color: 'var(--gray-800)', fontSize: '13px', fontWeight: '600' }
    const fontStyleThree = { color: 'var(--gray-800)', fontSize: '14px', fontWeight: '500' }

    const showResourceDetail = () => {
        setResourceInfo({
            access_resource_id: data.access_resource_id,
            resource_type: data.resource_type,
            status: data.status
        });
        setShowDetailModal(true);
    }

    return (
        <tr className="text-center" onClick={showResourceDetail}>
            <td className="custom-border">
                <div>
                    <div className='d-flex align-items-center'>
                        <div className='me-2'>
                            <img src={require(`../../../assets/icons/${getIconByResoruce(data.resource_type)}`)} alt="userIcon" />
                        </div>
                        <div>
                            <div className='mb-1 text-start'>
                                <p className='m-0' style={{ color: 'var(--gray-950)', fontSize: '14px', fontWeight: '600' }}>{data.name ? data.name : '-'}</p>
                                <p className='m-0' style={fontStyleTwo}>{data.natural_id ? data.natural_id : '-'}</p>
                            </div>
                        </div>
                    </div>

                </div>
            </td>

            <td className="custom-border">
                <div className='d-flex flex-wrap justify-content-around align-items-center'>
                    <p className='m-0' style={fontStyleThree}>{data.entry_date ? getDateOrTimeToReport(data.entry_date, 'DATE', false) : '-'}</p>
                    <p className='m-0' style={fontStyleTwo}>{data.entry_date ? getDateOrTimeToReport(data.entry_date, 'TIME', false) : '-'}</p>
                </div>
            </td>

            <td className="custom-border">
                <div className='d-flex flex-wrap justify-content-around align-items-center'>
                    <p className='m-0' style={fontStyleThree}>{data.egress_date ? getDateOrTimeToReport(data.egress_date, 'DATE', false) : '-'}</p>
                    <p className='m-0' style={fontStyleTwo}>{data.egress_date ? getDateOrTimeToReport(data.egress_date, 'TIME', false) : '-'}</p>
                </div>
            </td>

            <td className="custom-border">
                <p className='m-0'>
                    {
                        data.entry_date && data.egress_date ?
                            getTimeDiference(data.entry_date, data.egress_date)
                            :
                            data.entry_date ?
                                getHourAndMinutesFromSeconds(data.seconds)
                                :
                                '-'
                    }</p>
            </td>

            <td className="custom-border ">
                <div className='d-flex align-items-center justify-content-center'>
                    <div className={`d-flex align-items-center justify-content-center tablet-color ${data.resource_type ? colorRes(data.resource_type) : ''}`}>
                        <p className={`m-0`} style={{ color: 'var(--white)' }}>{data.resource_type ? getTranlationByKey(data.resource_type) : '-'}</p>
                    </div>
                </div>

            </td>

            <td className="text-start">
                <p className='m-0' style={fontStyleOne}>{data.contractor_name ? data.contractor_name : '-'}</p>
                <p className='m-0' style={fontStyleTwo}>{data.contractor_natural_id ? data.contractor_natural_id : '-'}</p>
            </td>

            <td className="">
                <i
                    style={{ color: '#98A0B6' }}
                    onClick={showResourceDetail}
                    type='button'
                    className="fa-solid fa-chevron-right d-block"
                >
                </i>
            </td>
        </tr>
    )
}
